@if (!drawerMode) {
  <app-page-breadcrumb [pageTitle]="pageTitle"></app-page-breadcrumb>
}

<ng-container *ngTemplateOutlet="drawerMode ? formBody : pageWrapper"></ng-container>

<ng-template #pageWrapper>
  <app-component-card>
    <ng-container *ngTemplateOutlet="formBody"></ng-container>
  </app-component-card>
</ng-template>

<ng-template #formBody>
  <div [class.p-6]="drawerMode">
  @if (loading) {
    <div class="py-8 text-center text-gray-500 dark:text-gray-400">Cargando...</div>
  } @else {
    <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">

      @if (error) {
        <div class="p-3 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
          <p class="text-error-600 dark:text-error-400 text-sm">{{ error }}</p>
        </div>
      }

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="md:col-span-2">
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Nombre de la regla *</label>
          <input type="text" formControlName="ruleName"
            [class.border-error-500]="hasError('ruleName')"
            class="w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Tipo *</label>
          <select formControlName="ruleType"
            class="w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
            @for (t of types; track t) { <option [ngValue]="t">{{ t }}</option> }
          </select>
          <button type="button" (click)="setTemplate()"
            class="mt-1 text-xs text-brand-600 hover:underline">Cargar plantilla JSON para este tipo</button>
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Prioridad</label>
          <input type="number" formControlName="priorityOrder"
            class="w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
          <p class="text-xs text-gray-500 mt-1">Menor = se evalúa primero.</p>
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Booking link ID</label>
          <input type="number" formControlName="idBookingLink"
            class="w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Booking link fallback ID</label>
          <input type="number" formControlName="idBookingLinkFallback"
            class="w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">User target ID</label>
          <input type="number" formControlName="userTargetId"
            class="w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
        </div>

        <div class="flex items-center gap-3 pt-6">
          <input id="isActiveRR" type="checkbox" formControlName="isActive"
            class="h-4 w-4 rounded border-gray-300 text-brand-500">
          <label for="isActiveRR" class="text-sm text-gray-700 dark:text-gray-300">Activa</label>
        </div>
      </div>

      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">Configuración (JSON) *</label>
        <textarea formControlName="ruleConfig" rows="8" (blur)="validateJson()"
          [class.border-error-500]="jsonError || hasError('ruleConfig')"
          class="w-full rounded-lg border border-gray-300 bg-transparent px-3 py-2 text-sm font-mono dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"></textarea>
        @if (jsonError) {
          <p class="text-xs text-error-600 mt-1">{{ jsonError }}</p>
        }
      </div>

      <div class="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
        <app-button variant="primary" type="submit" [disabled]="saving || form.invalid">
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
        </app-button>
      </div>
    </form>
  }
  </div>
</ng-template>
